module.exports = __webpack_public_path__ + "img/icon_ygq.b0141e27.png";